import {
    START_LOADING,
    END_LOADING,
    FETCH_All_TAX_SETTINGS,
    FETCH_TAX_SETTINGS_BY_ID,
    CREATE_TAX_SETTINGS,
    UPDATE_TAX_SETTINGS,
    DELETE_TAX_SETTINGS,
} from "../actions/constants";

const initialState = { 
    isLoading: false, 
    taxSettings: [], 
    taxById: null,
    currentPage: 1,
    numberOfPages: 1
};

const tax = (state = initialState, action) => {
    switch (action.type) {
        case START_LOADING:
            return { ...state, isLoading: true };
        case END_LOADING:
            return { ...state, isLoading: false };
        case FETCH_All_TAX_SETTINGS:
            return {
                ...state,
                taxSettings: action.payload.data,
                currentPage: action.payload.currentPage,
                numberOfPages: action.payload.numberOfPages
            };
        case FETCH_TAX_SETTINGS_BY_ID:
            return { ...state, taxById: action.payload.data };
        case CREATE_TAX_SETTINGS:
            return {
                ...state, 
                taxSettings: [...state.taxSettings, action.payload],
            };
        case UPDATE_TAX_SETTINGS:
            return {
                ...state,
                taxSettings: state.taxSettings.map((tax) =>
                    tax._id === action.payload._id ? action.payload : tax
                ),
            };
        case DELETE_TAX_SETTINGS:
            return {
                ...state,
                taxSettings: state.taxSettings.filter(
                    (tax) => tax._id !== action.payload
                ),
            };
        default:
            return state;
    }
};

export default tax;